export const Folder = `
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 304.523V783.06H882.375L1024 304.523H0Z"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M893.544 87.0067H375.735L286.381 0H0V217.517H893.544V87.0067Z"/>
`;



// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/icons/folder.js